import { createRoute } from '@tanstack/react-router';
import { AuthenticationPage } from '../components/authentication.tsx';
import { redirectSignedIn } from '../redirect-signed-in.ts';
import { Route as parent } from './root.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/sign-in',
  beforeLoad: redirectSignedIn,
  component: () => <AuthenticationPage mode="sign-in" />,
});
